/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of permission constraints */
export enum PermissionConstraintType {
  Temporal,
  Contextual,
  Conditional,
  ResourceBased,
  AttributeBased,
  RiskBased,
}

export type PermissionConstraintTypeArgs = PermissionConstraintType;

export function getPermissionConstraintTypeEncoder(): FixedSizeEncoder<PermissionConstraintTypeArgs> {
  return getEnumEncoder(PermissionConstraintType);
}

export function getPermissionConstraintTypeDecoder(): FixedSizeDecoder<PermissionConstraintType> {
  return getEnumDecoder(PermissionConstraintType);
}

export function getPermissionConstraintTypeCodec(): FixedSizeCodec<
  PermissionConstraintTypeArgs,
  PermissionConstraintType
> {
  return combineCodec(
    getPermissionConstraintTypeEncoder(),
    getPermissionConstraintTypeDecoder(),
  );
}
